(ns hypnos.dme.tile.field.referral-code
  "Field for the (referral) consult code."
  (:require [clojure.string :as str]
            [hypnos.graphql.queries :as queries]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [org (rf/subscribe [:dme/organization])]
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/code)]]
      [:div.field-body
       [:div.field
        [:p.control.is-expanded
         [:input.input
          {:type        :text
           :min-length  12
           :max-length  12
           :size        12
           :disabled    disabled
           :placeholder (when-not disabled (tr :ui.placeholder/consult-code))
           :value       (get-in @state [:referral :patient/last-consult :consult/code :value])
           :on-change   (fn [e]
                          (let [old-value (get-in @state [:referral :patient/last-consult :consult/code :value])
                                new-value (-> e .-target .-value)
                                changed?  (or (get-in @state [:referral :patient/last-consult :consult/code :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in [:referral :patient/last-consult :consult/code :value] (str/upper-case new-value))
                            (swap! state assoc-in [:referral :patient/last-consult :consult/code :dirty?] changed?)))
           :on-blur     (fn [_]
                          (swap! state assoc-in [:referral :patient/last-consult :consult/code :touched?] true))}]]
        (when-not disabled [:p.help (tr :ui.help/consult-code)])]
       (when-not disabled
         [:div.item
          [:button.button.is-success
           {:disabled (or (empty? (get-in @state [:referral :patient/last-consult :consult/code :value]))
                          (nil? (:organization/id @org)))
            :on-click (fn [_]
                        (let [consult-code (str/trim (get-in @state [:referral :patient/last-consult :consult/code :value]))]
                          (rf/dispatch [:amplify/query
                                        queries/get-patient-by-referral-code
                                        {:code consult-code}
                                        :dme/set-referral
                                        :dme/set-error])
                          (swap! state assoc :referral-looked-up? true)
                          (swap! state assoc-in [:referral :patient/last-consult :consult/code]
                                 {:value    consult-code
                                  :dirty?   false
                                  :touched? false})))}
           [:span.icon [:i.mdi.mdi-account-search]]
           [:span (tr :ui.label/lookup)]]])]])))
